var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { PagerNumericButtons } from './PagerNumericButtons';
import { PagerInput } from './PagerInput';
import { PagerPageSizes } from './PagerPageSizes';
import { PagerInfo } from './PagerInfo';
import { PagerNavigationButton } from './PagerNavigationButton';
import { messages, pagerFirstPage, pagerLastPage, pagerNextPage, pagerPreviousPage } from '../messages/main';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { getListeners, getTemplate, hasListener, templateRendering } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var RESPONSIVE_BREAKPOINT_MEDIUM = 600;
/**
 * @hidden
 */
var RESPONSIVE_BREAKPOINT_LARGE = 768;
/**
 * @hidden
 */
var PagerVue2 = {
  name: 'KendoPager',
  props: {
    pageSizeValue: [String, Number],
    total: Number,
    skip: Number,
    take: Number,
    pageSize: Number,
    settings: [Object, Boolean],
    buttonCount: {
      type: Number,
      default: 10
    },
    info: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'numeric',
      validator: function validator(value) {
        return ['numeric', 'input'].includes(value);
      }
    },
    pageSizes: {
      type: Array
    },
    previousNext: Boolean,
    messagesMap: Function,
    responsive: {
      type: Boolean,
      default: true
    },
    pagerRender: [String, Function, Object],
    width: [Number, String]
  },
  data: function data() {
    return {
      size: 'normal'
    };
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  },
  updated: function updated() {
    this.onWindowResize();
  },
  destroyed: !!isV3 ? undefined : function () {
    window.removeEventListener('resize', this.onWindowResize);
  },
  // @ts-ignore
  unmounted: function unmounted() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  inject: {
    kendoLocalizationService: {
      default: null
    },
    kendoIntlService: {
      default: null
    }
  },
  computed: {
    wrapperClass: {
      get: function get() {
        return {
          'k-widget': true,
          'k-pager': true,
          'k-pager-sm': this.size === 'small',
          'k-pager-md': this.size === 'medium'
        };
      }
    },
    totalPages: {
      get: function get() {
        return Math.ceil((this.$props.total || 0) / this.currentTake);
      }
    },
    currentPage: {
      get: function get() {
        return Math.floor((this.$props.skip || 0) / this.currentTake) + 1;
      }
    },
    currentTake: {
      get: function get() {
        return this.$props.take || this.$props.pageSize;
      }
    }
  },
  methods: {
    changePage: function changePage(page, e) {
      if (page > 0 && page <= this.totalPages) {
        this.$emit('pagechange', {
          skip: (page - 1) * this.currentTake,
          take: this.currentTake
        }, e);
      }
    },
    triggerPageChange: function triggerPageChange(state, event) {
      var pagesizechange = hasListener.call(this, 'pagesizechange');
      if (pagesizechange) {
        this.$emit('pagesizechange', state, event);
      } else {
        this.$emit('pagechange', state, event);
      }
    },
    onWindowResize: function onWindowResize() {
      var element = this.$el;
      if (!element || !this.$props.responsive || this.$props.settings.responsive === false) {
        return;
      }
      var width = element.offsetWidth;
      if (width < RESPONSIVE_BREAKPOINT_MEDIUM) {
        this.size = 'small';
      } else if (width >= RESPONSIVE_BREAKPOINT_MEDIUM && width < RESPONSIVE_BREAKPOINT_LARGE) {
        this.size = 'medium';
      } else {
        this.size = 'large';
      }
    },
    transformDimesion: function transformDimesion(initialValue) {
      return typeof initialValue === 'string' ? initialValue.endsWith('px') ? initialValue : initialValue + 'px' : initialValue + 'px';
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var kendoIntlService = inject('kendoIntlService', {});
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoIntlService: kendoIntlService,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  // @ts-ignore 
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
      skip = _a.skip,
      take = _a.take,
      total = _a.total,
      pageSizes = _a.pageSizes,
      buttonCount = _a.buttonCount,
      messagesMap = _a.messagesMap,
      info = _a.info,
      type = _a.type,
      previousNext = _a.previousNext,
      pageSizeValue = _a.pageSizeValue;
    var settings = __assign({
      pageSizes: pageSizes,
      buttonCount: buttonCount,
      info: info,
      previousNext: previousNext,
      type: type,
      skip: skip,
      take: take,
      total: total,
      messagesMap: messagesMap,
      pageSizeValue: pageSizeValue
    }, this.$props.settings);
    var pagerRender = this.$props.pagerRender || this.$props.settings.pagerRender;
    var pagerRenderTemplate = pagerRender ? templateRendering.call(this, pagerRender, getListeners.call(this)) : null;
    var localizationService = provideLocalizationService(this);
    var firstPageMessage = messagesMap ? messagesMap(pagerFirstPage) : {
      messageKey: pagerFirstPage,
      defaultMessage: messages[pagerFirstPage]
    };
    var previousPageMessage = messagesMap ? messagesMap(pagerPreviousPage) : {
      messageKey: pagerPreviousPage,
      defaultMessage: messages[pagerPreviousPage]
    };
    var nextPageMessage = messagesMap ? messagesMap(pagerNextPage) : {
      messageKey: pagerNextPage,
      defaultMessage: messages[pagerNextPage]
    };
    var lastPageMessage = messagesMap ? messagesMap(pagerLastPage) : {
      messageKey: pagerLastPage,
      defaultMessage: messages[pagerLastPage]
    };
    var changer = settings.type === 'numeric' ?
    // @ts-ignore
    h(PagerNumericButtons, {
      size: this.size,
      attrs: this.v3 ? undefined : {
        size: this.size,
        buttonCount: settings.buttonCount || 0,
        totalPages: this.totalPages,
        currentPage: this.currentPage
      },
      buttonCount: settings.buttonCount || 0,
      totalPages: this.totalPages,
      currentPage: this.currentPage,
      onPagechange: this.changePage,
      on: this.v3 ? undefined : {
        "pagechange": this.changePage
      }
    }) :
    // @ts-ignore
    h(PagerInput, {
      currentPage: this.currentPage,
      attrs: this.v3 ? undefined : {
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        messagesMap: messagesMap
      },
      totalPages: this.totalPages,
      onPagechange: this.changePage,
      on: this.v3 ? undefined : {
        "pagechange": this.changePage
      },
      messagesMap: messagesMap
    });
    var first, prev, next, last;
    if (settings.previousNext) {
      first =
      // @ts-ignore function children
      h(PagerNavigationButton, {
        "class": 'k-pager-first' + (this.currentPage === 1 ? ' k-disabled' : ''),
        page: 1,
        attrs: this.v3 ? undefined : {
          page: 1,
          title: localizationService.toLanguageString(firstPageMessage.messageKey, firstPageMessage.defaultMessage),
          icon: 'caret-alt-to-left'
        },
        title: localizationService.toLanguageString(firstPageMessage.messageKey, firstPageMessage.defaultMessage),
        icon: 'caret-alt-to-left',
        onPagechange: this.changePage,
        on: this.v3 ? undefined : {
          "pagechange": this.changePage
        }
      });
      prev =
      // @ts-ignore function children
      h(PagerNavigationButton, {
        "class": this.currentPage === 1 ? ' k-disabled' : '',
        page: this.currentPage - 1,
        attrs: this.v3 ? undefined : {
          page: this.currentPage - 1,
          title: localizationService.toLanguageString(previousPageMessage.messageKey, previousPageMessage.defaultMessage),
          icon: 'caret-alt-left'
        },
        title: localizationService.toLanguageString(previousPageMessage.messageKey, previousPageMessage.defaultMessage),
        icon: 'caret-alt-left',
        onPagechange: this.changePage,
        on: this.v3 ? undefined : {
          "pagechange": this.changePage
        }
      });
      next =
      // @ts-ignore function children
      h(PagerNavigationButton, {
        "class": this.currentPage === this.totalPages ? ' k-disabled' : '',
        page: this.currentPage + 1,
        attrs: this.v3 ? undefined : {
          page: this.currentPage + 1,
          title: localizationService.toLanguageString(nextPageMessage.messageKey, nextPageMessage.defaultMessage),
          icon: 'caret-alt-right'
        },
        title: localizationService.toLanguageString(nextPageMessage.messageKey, nextPageMessage.defaultMessage),
        icon: 'caret-alt-right',
        onPagechange: this.changePage,
        on: this.v3 ? undefined : {
          "pagechange": this.changePage
        }
      });
      last =
      // @ts-ignore function children
      h(PagerNavigationButton, {
        "class": 'k-pager-last' + (this.currentPage === this.totalPages ? ' k-disabled' : ''),
        page: this.totalPages,
        attrs: this.v3 ? undefined : {
          page: this.totalPages,
          title: localizationService.toLanguageString(lastPageMessage.messageKey, lastPageMessage.defaultMessage),
          icon: 'caret-alt-to-right'
        },
        title: localizationService.toLanguageString(lastPageMessage.messageKey, lastPageMessage.defaultMessage),
        icon: 'caret-alt-to-right',
        onPagechange: this.changePage,
        on: this.v3 ? undefined : {
          "pagechange": this.changePage
        }
      });
    }
    var renderPageSizes = settings.pageSizes &&
    // @ts-ignore function children
    h(PagerPageSizes, {
      onPagechange: this.triggerPageChange,
      on: this.v3 ? undefined : {
        "pagechange": this.triggerPageChange
      },
      pageSize: this.currentTake,
      attrs: this.v3 ? undefined : {
        pageSize: this.currentTake,
        pageSizes: settings.pageSizes,
        value: settings.pageSizeValue,
        messagesMap: messagesMap
      },
      pageSizes: settings.pageSizes,
      value: settings.pageSizeValue,
      messagesMap: messagesMap
    });
    var infoElement = !settings.info ? '' :
    // @ts-ignore function children
    h(PagerInfo, {
      totalPages: this.$props.total,
      attrs: this.v3 ? undefined : {
        totalPages: this.$props.total,
        skip: this.$props.skip,
        currentPage: this.currentTake,
        messagesMap: messagesMap
      },
      skip: this.$props.skip,
      currentPage: this.currentTake,
      messagesMap: messagesMap
    });
    var pagerContent = getTemplate.call(this, {
      h: h,
      template: pagerRenderTemplate,
      additionalProps: __assign(__assign({}, this.$props), {
        current: this.currentPage
      }),
      additionalListeners: {
        pagechange: this.triggerPageChange
      }
    });
    var width = this.transformDimesion(this.$props.width);
    return pagerRender ? h("div", {
      "class": this.wrapperClass,
      style: {
        width: width
      },
      role: "navigation",
      attrs: this.v3 ? undefined : {
        role: "navigation"
      }
    }, [pagerContent]) : h("div", {
      "class": this.wrapperClass,
      style: {
        width: width
      },
      role: "navigation",
      attrs: this.v3 ? undefined : {
        role: "navigation"
      }
    }, [first, prev, changer, next, last, renderPageSizes, infoElement]);
  }
};
/**
 * @hidden
 */
var Pager = PagerVue2;
export { Pager, PagerVue2 };